import autoBind from 'auto-bind';
import axios from 'axios';
import { debounce } from 'lodash';
import ReLogin from '../../api/relogin';

let ws, pingInterval;

class WebsocketsGateway {
  constructor () {
    autoBind(this);
    this.providers = {};
  }

  addProvider (name, provider) {
    this.providers[name] = provider;
  }

  Init (self) {
    console.info('WebsocketsGateway.Init');
    this.self = self;
    this.connect();
  }

  Fin () {
    console.info('WebsocketsGateway.Fin');
    Object.values(this.providers).forEach(provider => {
      if (typeof provider.Fin === 'function') {
        provider.Fin();
      }
    });
    setTimeout(() => {
      ws && ws?.close();
    });
    pingInterval && clearInterval(pingInterval);
  }

  connect () {
    let wsHost;
    if (process.env.VUE_APP_API_HOST && process.env.VUE_APP_API_HOST.length) {
      wsHost = (process.env.VUE_APP_API_HOST.startsWith('https') ? 'wss' : 'ws') + '://' + process.env.VUE_APP_API_HOST.substr(7);
    } else {
      wsHost = (window.location.protocol.startsWith('https') ? 'wss' : 'ws') + '://' + window.location.host + '/';
    }
    if (!axios.defaults.headers.common || !axios.defaults.headers.common.Authorization) {
      return false;
    }

    wsHost += 'ws/websockets-gateway/api/v1/events/connect?t=' + axios.defaults.headers.common.Authorization.substr(7);

    ws = new WebSocket(wsHost);

    ws.onopen = () => {
      console.log('WebsocketsGateway.initWS | подключенно');
      this.onOpen();
    };

    ws.onclose = err => {
      console.log('WebsocketsGateway.initWS | соеденение закрыто причина: ', err);
      this.reconnect(err);
    };

    ws.onerror = err => {
      console.log('WebsocketsGateway.initWS | ошибка: ', err);
      this.reconnect(err);
    };

    ws.onmessage = this.onMessage;
  }

  ping () {
    const pingCall = () => {

    };
    pingInterval && clearInterval(pingInterval);
    pingInterval = setInterval(pingCall, 5 * 60 * 1000);
    pingCall();
  }

  reconnect = debounce(async err => {
    console.log('WebsocketsGateway.reconnect | Соединение закрыто, код=', err.code, ', причина=', err.reason);

    if (err.code === 1006) {
      await new ReLogin(this.self.$store).run();
    }

    ws = undefined;
    this.connect();
  }, 5000);

  onOpen () {
    try {
      const topics = ['converter'];
      Object.values(this.providers).forEach(provider => {
        if (Array.isArray(provider.topics)) {
          topics.push(...provider.topics);
        } else {
          topics.push(provider.topics);
        }
      });
      ws.send(JSON.stringify({
        type: 'subscribe',
        header: {
          topics,
          authenticate: axios.defaults.headers.common.Authorization.substr(7),
          request_id: Date.now() + '-' + Math.random(),
        },
      }));
    } catch (e) {
      console.error('WebsocketsGateway.reconnect | OnNew | e = ', e);
    }
  }

  onMessage ({ data }) {
    const dataJson = JSON.parse(data);
    console.log('WebsocketsGateway.onMessage | dataJson = ', dataJson);

    if (this.providers[dataJson.header.topic]) {
      this.providers[dataJson.header.topic].onMessage(dataJson);
    } else if (dataJson.header.topic === 'converter') {
      if (dataJson.type === 'notify') {
        this.self.$store.commit('group-contact/convert/SET_TASK_PROGRESS', {
          task_id: dataJson.body.task_id,
          progress: dataJson.body.progress,
          isWS: true,
        });
      }
    }
  }
}

export default new WebsocketsGateway();
